/**
 *@Author  ahuan
 *@Description
 *@Date 2024/6/17
 **/
import {ref} from "vue"
export default function (){
    let currentModal = ref("tagList");

    return {
        currentModal
    }
}
